import {
  COMMON_SAVE_MODAL_DATA,
  COMMON_CLEAN_MODAL_DATA,
  COMMON_UPDATE_MODAL_DATA
} from './constants'

/**
 * Para guardar datos referidos a la persistencia del modal al recargar
 * @param {any} data - Los datos a guardar
 */
export const saveModalData = (data) => {
  return {
    type: COMMON_SAVE_MODAL_DATA,
    data: data,
  }
}

/**
 * Para agregar nuevos datos referidos a la persistencia del modal al recargar
 * @param {object} data - Los datos a agregar
 */
export const updateModalData = (data) => {
  return {
    type: COMMON_UPDATE_MODAL_DATA,
    data: data,
  }
}

/**
 * Para limpiar los datos de persistencia del modal
 */
export const cleanModalData = () => {
  return {
    type: COMMON_CLEAN_MODAL_DATA,
  }
}

export const reducer = (state, action) => {
  switch (action.type) {
    case COMMON_SAVE_MODAL_DATA:
      return {
        ...state,
        modalData: action.data,
      }

    case COMMON_CLEAN_MODAL_DATA:
      return {
        ...state,
        modalData: {},
      }
    
    case COMMON_UPDATE_MODAL_DATA:
        return {
            ...state,
            modalData: {
                ...state.modalData,
                ...action.data
            }
        }

    default:
      return state
  }
}